export type Recommendation = {
  id: string;
  title: string;
  description?: string;
  savingsMs?: number;
  savingsBytes?: number;
};

type Props = { items: Recommendation[]; locale: "de" | "en" };

function fmtSavings(loc: "de" | "en", r: Recommendation): string | null {
  if (r.savingsMs && r.savingsMs > 0) {
    const s = (r.savingsMs / 1000).toFixed(1).replace(".", loc === "de" ? "," : ".");
    return loc === "de" ? `Einsparpotenzial: ${s}s` : `Potential savings: ${s}s`;
  }
  if (r.savingsBytes && r.savingsBytes > 0) {
    const kb = Math.round(r.savingsBytes / 1024);
    return loc === "de" ? `Einsparpotenzial: ${kb} KB` : `Potential savings: ${kb} KB`;
  }
  return null;
}

export function LighthouseRecommendations({ items, locale }: Props) {
  if (!items.length) return null;
  const head = locale === "de" ? "Top-3 Verbesserungs-Hebel" : "Top 3 improvement opportunities";
  const sub =
    locale === "de"
      ? "Sortiert nach geschätztem Performance-Gewinn."
      : "Sorted by estimated performance gain.";

  return (
    <section aria-label={head} className="mt-10">
      <h2 className="font-display text-2xl text-ink md:text-3xl">{head}</h2>
      <p className="mt-2 text-sm text-ink-3">{sub}</p>
      <ol className="mt-6 space-y-4">
        {items.slice(0, 3).map((r, i) => {
          const savings = fmtSavings(locale, r);
          return (
            <li
              key={r.id}
              className="rounded-lg border border-rule bg-white p-5 md:p-6"
            >
              <div className="flex items-baseline gap-4">
                <span className="font-mono text-xs uppercase tracking-[0.14em] text-ink-4">
                  {String(i + 1).padStart(2, "0")}
                </span>
                <h3 className="font-display text-lg leading-snug text-ink md:text-xl">
                  {r.title}
                </h3>
              </div>
              {r.description && (
                <p className="mt-3 pl-10 text-sm leading-relaxed text-ink-2">{r.description}</p>
              )}
              {savings && (
                <p className="mt-3 pl-10 font-mono text-[11px] uppercase tracking-[0.12em] text-lime-deep">
                  {savings}
                </p>
              )}
            </li>
          );
        })}
      </ol>
    </section>
  );
}
